import script from "./CourseModalImageSettingsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseModalImageSettingsMenu.vue?vue&type=script&setup=true&lang=js"

import "./CourseModalImageSettingsMenu.vue?vue&type=style&index=0&id=302bccbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302bccbf"]])

export default __exports__